export interface TrackingLocation {
  city: string;
  region: string;
  countryCode: string;
}

export interface TrackingEvent {
  eventType: string;
  label: string;
  city: string;
  region: string;
  countryCode: string;
  occurredAt: string;
}

export interface UpcomingStage {
  key: string;
  label: string;
}

export interface PublicTrackingView {
  trackingCode: string;
  orderReference: string;
  currentStatus: string;
  currentStatusLabel: string;
  origin: TrackingLocation;
  currentLocation: TrackingLocation | null;
  destination: TrackingLocation;
  events: TrackingEvent[];
  upcoming: UpcomingStage[];
  lastUpdated: string;
}

export class TrackingApiError extends Error {
  status: number;
  constructor(status: number, message: string) {
    super(message);
    this.status = status;
  }
}

export async function fetchTrackingView(code: string, language: string): Promise<PublicTrackingView> {
  const res = await fetch(`/api/tracking/${encodeURIComponent(code)}?lang=${encodeURIComponent(language)}`);
  if (!res.ok) {
    const body = await res.json().catch(() => ({}));
    throw new TrackingApiError(res.status, body.error ?? res.statusText);
  }
  return res.json();
}

export const TRACKING_CODE_PATTERN = /^PKG-[A-Z]{2}-[23456789A-HJ-NP-Z]{4}-[23456789A-HJ-NP-Z]{4}-[23456789A-HJ-NP-Z]{4}$/;
